import { render, staticRenderFns } from "./SelectWrapper.vue?vue&type=template&id=a9a65fb0&"
import script from "./SelectWrapper.vue?vue&type=script&lang=js&"
export * from "./SelectWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SelectWrapper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports